import React from 'react';
import ComponentFactory from './ComponentFactory';
import './RegisterComponents';
import { GlobalContext, MetaContext } from '../GlobalContext';
import '../App.css';
import FingerprintProvider from './foundation/FingerprintProvider';
import { useMetaState } from '../hooks/metaState';

const App = (props) => {
 
  let data = {}
  const [metaState, metaDispatch] = useMetaState();
  if (props?.data) {
    data = props.data
  }
  else if (typeof window != 'undefined' && window.__APPSTATE__) {
    data = window.__APPSTATE__;
  }
 
  return (<GlobalContext.Provider value={{state:data}}>
    <MetaContext.Provider value={metaState}>
    {data?.layout?.map(componentData => {
      const Component = ComponentFactory.get(componentData.componentName);

      return <Component key={componentData.uuid} state={data} componentData={componentData} />
    })}
    <FingerprintProvider metaDispatch={metaDispatch} />
    </MetaContext.Provider >
  </GlobalContext.Provider>)
}
export default App;